type ForegroundPromptListener = () => void;

const guidedTourBlockers = new Set<string>();
const listeners = new Set<ForegroundPromptListener>();

const notify = () => listeners.forEach((listener) => listener());

export const isForegroundPromptBlocked = () => guidedTourBlockers.size > 0;

export const subscribeToForegroundPromptBlockers = (listener: ForegroundPromptListener) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const setGuidedTourPromptBlocker = (tourKey: string, blocked: boolean) => {
  const wasBlocked = guidedTourBlockers.has(tourKey);
  if (blocked) guidedTourBlockers.add(tourKey);
  else guidedTourBlockers.delete(tourKey);
  if (wasBlocked !== blocked) notify();
};

// Other foreground tasks share the same pause/resume behavior as guided tours.
export const setForegroundPromptBlocker = setGuidedTourPromptBlocker;

export const clearGuidedTourPromptBlockers = () => {
  if (!guidedTourBlockers.size) return;
  guidedTourBlockers.clear();
  notify();
};
